import { PlaylistAdd } from '@mui/icons-material'
import { Button, Stack, Tooltip, Typography } from '@mui/material'
import { useGridApiContext } from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RowGroupingPopover } from './components/RowGroupingPopover'
import { getRowGroupingModelCriteriaFromGridRowGroupingState } from './helpers'

export const RowGrouping: React.FC = () => {
  const { t } = useTranslation('common')
  const { state } = useGridApiContext().current
  const [displayRowGroupingPopover, setDisplayRowGroupingPopover] = useState(false)

  const ref = useRef<HTMLButtonElement | null>(null)

  const currentRowGroupingColumn = useMemo(() => {
    const currentRowGroupingModelCriteria = getRowGroupingModelCriteriaFromGridRowGroupingState(state.rowGrouping)
    return isNil(currentRowGroupingModelCriteria) ? undefined : state.columns.lookup[currentRowGroupingModelCriteria]
  }, [state.rowGrouping, state.columns.lookup])

  const handleDisplayPopover = () => setDisplayRowGroupingPopover(true)
  const handleHidePopover = () => setDisplayRowGroupingPopover(false)

  const getButtonLabel = () => {
    if (isNil(currentRowGroupingColumn)) {
      return t('table.table-toolbar.empty-row-grouping-button-label')
    }
    return t('table.table-toolbar.row-grouping-button-label', {
      columnList: currentRowGroupingColumn.headerName,
    })
  }

  return (
    <>
      <Tooltip title={t('table.table-toolbar.tooltip-row-grouping')}>
        <Button
          className={!isNil(currentRowGroupingColumn) ? 'active' : undefined}
          ref={ref}
          onClick={handleDisplayPopover}
          variant="text"
          color="secondary"
          startIcon={
            <Stack direction="row" gap="2px" sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <PlaylistAdd sx={{ width: 16 }} />
              <Typography sx={{ m: 0, p: 0, ml: '1px' }} variant="body-medium">
                {getButtonLabel()}
              </Typography>
            </Stack>
          }
        />
      </Tooltip>
      <RowGroupingPopover anchorElement={ref.current} open={displayRowGroupingPopover} onClose={handleHidePopover} />
    </>
  )
}
